import React from "react"
import Beneficio1 from "../../images/beneficio-1.png"
import Beneficio2 from "../../images/beneficio-2.png"
import Beneficio3 from "../../images/beneficio-3.png"
import Beneficio4 from "../../images/beneficio-4.png"

const Beneficios = () => {
  return (
    <section className="bg-neutral">
      <div className="container mx-auto px-6 py-12">
        <h3 className="font-normal leading-tight text-5xl text-center pb-8">
          <span className="text-secondary block font-bold">4 benefits</span> of
          working with us.
        </h3>
        <div className="grid grid-cols-1 grid-rows-1 md:grid-cols-2 md:grid-rows-2 gap-8 text-xl">
          <div id="beneficio1">
            <div className="flex flex-col">
              <div className="mx-auto md:flex-grow-0">
                <img
                  src={Beneficio1}
                  alt="Flexible Contracts"
                  className="mx-auto"
                />
              </div>
              <h3 className="text-3xl pb-4 text-center">
                <span className="font-bold text-secondary">Flexible </span>
                Contracts
              </h3>
              <p className="text-center">
                We agree with our clients the billing of services to facilitate
                administrative and financial flows
              </p>
            </div>
          </div>

          <div id="beneficio2">
            <div className="flex flex-col">
              <div className="mx-auto md:flex-grow-0">
                <img
                  src={Beneficio2}
                  alt="Account Manager"
                  className="mx-auto"
                />
              </div>
              <h3 className="text-3xl pb-4 text-center">
                <span className="font-bold text-secondary">Account </span>
                Manager
              </h3>
              <p className="text-center">
                Ready to scale up your team, full-time availability
              </p>
            </div>
          </div>

          <div id="beneficio3">
            <div className="flex flex-col">
              <div className="mx-auto md:flex-grow-0">
                <img
                  src={Beneficio3}
                  alt="Monthly Billing"
                  className="mx-auto"
                />
              </div>
              <h3 className="text-3xl pb-4 text-center">
                <span className="font-bold text-secondary">Flexible </span>
                billing
              </h3>
              <p className="text-center">
                We offer short and long-term contracts, with flexible
                cancellation
              </p>
            </div>
          </div>

          <div id="beneficio4">
            <div className="flex flex-col">
              <div className="mx-auto md:flex-grow-0">
                <img src={Beneficio4} alt="Recruitment" className="mx-auto" />
              </div>
              <h3 className="text-3xl pb-4 text-center">
                <span className="font-bold text-secondary">Specialized </span>
                recruitment
              </h3>
              <p className="text-center">
                We have a team focused on talent-hunting 24/7
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Beneficios
